<!-- <app-popup *ngIf="newCRMPopup" (close)="closeNewTicket($event)" [component]="'newCRM'" ></app-popup> -->
<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="close()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>Textbausteine</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="disableReorder = !disableReorder">
        @if(disableReorder){ <ion-icon slot="icon-only" name="fa-sort"></ion-icon> }
        @else { <ion-icon slot="icon-only" name="fa-check"></ion-icon> }
      </ion-button>
      <ion-button size="small" (click)="addTextModule()">
        <ion-icon slot="icon-only" name="fa-plus"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>  


<ion-content #ioContent ArrowKeyUseable [arrowKeysOptions]="arrowKeysOptions">
  <ion-searchbar #searchbar placeholder="Suchen..." [(ngModel)]="searchText" (ngModelChange)="search()"></ion-searchbar>

  <div id="wrapper">
    <div id="modules-list" [class.reorder-active]="!disableReorder">
      
      <ion-reorder-group [disabled]="disableReorder" (ionItemReorder)="handleReorder($any($event))">
        <ion-item *ngFor="let module of snippetsFiltered; let i = index" (click)="selectModule(module)" [class.active]="selectedSnippet == module"  (mouseenter)="arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="arrowKeysOptions.mouseMove.next(true)">
          <ion-label>{{module.title}}</ion-label>
          <div class="hover-bttn" (click)="openModuleActions($event, module)" *ngIf="disableReorder">
            <ion-icon name="fa-ellipsis-vertical"></ion-icon>
          </div> 
          <ion-reorder slot="start">
            <ion-icon name="fa-grip-lines"></ion-icon>
          </ion-reorder>
        </ion-item>
      </ion-reorder-group>
      

      <div class="loading" *ngIf="loadingList">
        <ion-icon name="fa-spinner" class="spinner"></ion-icon>
      </div>

      <p class="no-content" *ngIf="!snippetsFiltered.length && !loadingList" style="font-size: 14px;">
        Keine Textbausteine gefunden
      </p>
    </div>
  
    <div id="module-preview" [ngStyle]="{'bottom' : showFooter ? '72px' : '15px' }">

      
      @if(disableReorder && !selectedSnippet && !loadingContent){
        <p class="no-content">
          Kein Textbaustein ausgewählt
        </p>
      }@else if(!disableReorder){
        <p class="no-content">
          Reihenfolge wird bearbeitet...
        </p>      
      }@else if(loadingContent && disableReorder){
        <div class="loading" *ngIf="loadingContent">
          <ion-icon name="fa-spinner" class="spinner"></ion-icon>
        </div>
      }@else {
        <div id="preview-content" class="mainHtmlContent" [innerHTML]="selectedSnippet?.content| safeHtml" *ngIf="!loadingContent"></div>
      }

    </div>
  </div>
</ion-content>

<ion-footer class="ion-no-border" *ngIf="showFooter">
  <ion-toolbar style="--background: var(--background2)">
    <ion-buttons slot="end">
      <ion-chip mode="ios" class="button-chip" (click)="close()">Abbrechen</ion-chip>
      <ion-chip mode="ios" class="button-chip" (click)="selectActiveModule()" style="--background: rgba(var(--blueRGB), 0.5)">Textbaustein übernehmen</ion-chip>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

  